/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Swedish (sv) string table · dr-ronlan.html
   English is the source of truth in the HTML; this file supplies the
   Swedish counterpart for each page-specific data-i18n key. Shared
   chrome (nav, announce, footer) lives in i18n-sv.js.
   Proper names, institution names, journal titles, patent numbers and
   molecular names stay in their original form.
═════════════════════════════════════════════════════════════════════ */
(function () {
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.sv = window.TD_I18N.sv || {};
  Object.assign(window.TD_I18N.sv, {

    /* ── Meta ── */
    'ronlan.docTitle': 'Dr. K. Alvin Ronlán · Forskning och meriter — Transderma',

    /* ── Page header ── */
    'ronlan.headLabel': 'Forskning och meriter',
    'ronlan.headTitle': 'Dr. K. Alvin <em>Ronlán</em>',
    'ronlan.headSub': 'Grundare, Director of R&amp;D. Tre decennier av fenolkemi, nu tillämpad på huden.',

    /* ── Quick facts ── */
    'ronlan.facts.label': 'Snabbfakta',
    'ronlan.facts.bornK': 'Född',
    'ronlan.facts.bornV': '15 augusti 1942, Köpenhamn, Danmark',
    'ronlan.facts.domK': 'Bosatt',
    'ronlan.facts.domV': 'Florida, USA',
    'ronlan.facts.langK': 'Språk',
    'ronlan.facts.langV': 'Danska, svenska, engelska, tyska',
    'ronlan.facts.roleK': 'Nuvarande roll',
    'ronlan.facts.roleV': 'R&amp;D Director, Alron Chemical Co AB · Medgrundare, ProBios Laboratories, Inc.',

    /* ── Education ── */
    'ronlan.eduLabel': 'Utbildning',
    'ronlan.eduTitle': 'Fyra examina,<br><em>tre länder.</em>',
    'ronlan.edu1h': 'B.Sc. · matematik, fysik, kemi',
    'ronlan.edu1p': 'Köpenhamns universitet och Danmarks Tekniska Institut.',
    'ronlan.edu2h': 'M.Sc. · fysik och kemi',
    'ronlan.edu2p': 'Uppsala universitet, Sverige.',
    'ronlan.edu3h': 'Ph.D.',
    'ronlan.edu3p': 'Kungliga Tekniska högskolan, Stockholm, Sverige.',
    'ronlan.edu4h': 'Teknologie doktor',
    'ronlan.edu4p': 'Lunds universitet, Sverige.',

    /* ── Career ── */
    'ronlan.carLabel': 'Karriär',
    'ronlan.carTitle': 'Från akademin<br><em>till laboratoriet.</em>',
    'ronlan.carIntro': 'Sex decennier inom undervisning, forskning och tillämpad kemi. Höjdpunkterna nedan.',
    'ronlan.car1h': 'Amanuens, Uppsala universitet',
    'ronlan.car1p': 'Tidig undervisningstjänst under magisterstudierna.',
    'ronlan.car2h': 'Forskningsassistent, Kungliga Tekniska högskolan, Stockholm',
    'ronlan.car2p': 'Doktorandtiden i Stockholm.',
    'ronlan.car3h': 'Docent, Lunds universitet',
    'ronlan.car3p': 'Påbörjar arbete inom fenolkemi och anodisk oxidation som senare ligger till grund för Transdermas formulering.',
    'ronlan.car4h': 'Universitetslektor, Lunds universitet',
    'ronlan.car5h': 'Professor, Lunds universitet',
    'ronlan.car5p': 'Befordras till professor i bioorganisk kemi och leder forskningsgruppen kring fenoliska antioxidanter och katjonradikaler.',
    'ronlan.car6h': 'Prefekt, Kemiska institutionen, Lunds universitet',
    'ronlan.car6p': 'Leder kemiska institutionen vid Lunds universitet.',
    'ronlan.car7h': 'Director of R&amp;D, Alron Chemical Co AB',
    'ronlan.car7p': 'Pågående · grundade laboratoriet 1977 för ytkemi, ytfysik och förbränningskatalys. Samma år grundas också Alron Japan, Inc. i Tokyo.',
    'ronlan.car8h': 'Gästprofessor, University of California, Santa Cruz',
    'ronlan.car8p': 'Tillämpar tidig artificiell intelligens på kemiska och biokemiska problem.',
    'ronlan.car9h': 'Medgrundare och R&amp;D Director, ProBios Laboratories, Inc.',
    'ronlan.car9p': 'Tillsammans med Graziella Gallelli Ronlan. Forskning och utveckling baserad i Florida.',
    'ronlan.car10h': 'Konsult, Erco Pharmaceuticals',
    'ronlan.car10p': 'Medförfattare till patent på kontrastmedel och blodtryckssänkande läkemedel.',
    'ronlan.car11h': 'Expedition till Östafrika',
    'ronlan.car11p': 'Organiserade och ledde en fyra månader lång expedition i Kenya, Tanzania och Uganda för insamling av medicinalväxter.',

    /* ── Publications ── */
    'ronlan.pubLabel': 'Utvalda publikationer',
    'ronlan.pubTitle': 'Fenoler, antioxidanter,<br><em>katjonradikaler.</em>',
    'ronlan.pubIntro': 'Tio referentgranskade artiklar som visar den kemi som ligger till grund för Transdermas formuleringar. Hela bibliografin med 31 artiklar finns i CV-nedladdningen.',
    'ronlan.pub1': '<em>Phenol Dehydrogenation. Intramolecular Oxidative Coupling of Dihydropiceatannol.</em> Acta Chem. Scand., 23, 249 (1969). Med Holger Erdtman.',
    'ronlan.pub2': '<em>The Structure of Mezerein, A Major Toxic Principle of Daphne Mezerum L.</em> Tetrahedron Letters, 1970, 4261. Med Börje Wickberg.',
    'ronlan.pub3': '<em>Coupling of Phenols via an Anodically Generated Ion.</em> Chem. Commun., 1971, 1643.',
    'ronlan.pub4': '<em>Anodic Oxidation of Phenolic Compounds. Part II. Products and Mechanisms of the Anodic Oxidation of Hindered Phenols.</em> J. Chem. Soc., C, 1971, 3241. Med V.D. Parker.',
    'ronlan.pub5': '<em>Kinetics and Mechanisms of the Reaction of Organic Cation Radicals and Dications.</em> J. Amer. Chem. Soc., 96, 5108 (1974). Med V.D. Parker och U. Svanholm.',
    'ronlan.pub6': '<em>Anodic Oxidation of Phenolic Compounds. Part V. Anodic Methoxylation of Phenols.</em> J. Chem. Soc. Perk I, 1978, 696.',
    'ronlan.pub7': '<em>Anodic Coupling of Simple Aryl Ethers.</em> Tetrahedron Letters, 1972, 2272.',
    'ronlan.pub8': '<em>The Direct Observation of Intermediates During the Oxidative Cyclization of Phenol Ethers.</em> Acta Chem. Scand., 1974.',
    'ronlan.pub9': '<em>Electrosynthesis of Medium and Large Sized Rings by Oxidative Cyclization.</em> J. Org. Chem., 39, 1014 (1974).',
    'ronlan.pub10': '<em>The Relative Ease of Oxidation of Phenols and Phenol Ethers.</em> Acta Chem. Scand., 1976.',
    'ronlan.pub11': '<em>Systematic Derivation of Chemical Procedures for Transforming Surplus Hazardous Chemicals to Useful Products.</em> Journal of Hazardous Materials, 1984.',
    'ronlan.pubFull': 'Hela bibliografin med 31 referentgranskade artiklar finns i CV-nedladdningen.',

    /* ── Patents ── */
    'ronlan.patLabel': 'Patent',
    'ronlan.patTitle': 'Sju patent,<br><em>ett centralt för huden.</em>',
    'ronlan.patFeatBadge': 'Grunden för Transderma',
    'ronlan.patFeatTitle': 'US Pat. 20080118449 · Cosmetic Formulations of Piceatannol and Retinoids and Methods of Use Thereof',
    'ronlan.patFeatBody': 'Detta patent är den kemiska grunden för Transderma. Piceatannol är den aktiva substansen i Serum R; retinoider (retinylpalmitat) är den aktiva substansen i Serum A. Patentet beskriver hur dessa två molekyler tillsammans verkar på huden.',
    'ronlan.patFeatLinkA': 'Köp Serum R',
    'ronlan.patFeatLinkB': 'Köp Serum A',
    'ronlan.pat1': 'US Pat. 6,500,465 · Desinficerande och sporicid komposition · sanering av byggnader.',
    'ronlan.pat2': 'US Pat. 5,540,767 · Däckbalanseringskomposition och metod.',
    'ronlan.pat3': 'US Pat. 5,431,726 · Balanseringskomposition.',
    'ronlan.pat4': 'US Pat. 4,867,792 · Däckbalanseringskomposition.',
    'ronlan.pat5': 'European Patent EP1196299 · Däckbalanseringskompositioner.',
    'ronlan.pat6': 'European Patent EP0281252 · Däckbalanseringskomposition och metod.',

    /* ── Shop CTA ── */
    'ronlan.ctaLabel': 'Den tillämpade kemin',
    'ronlan.ctaTitle': 'Patentet finns<br><em>i flaskan.</em>',
    'ronlan.ctaBody': 'Två av Transdermas fem serum kommer direkt från Dr. Ronláns kosmetiska patent. Börja där, eller prova hela systemet i Discovery Kit.',
    'ronlan.ctaBtnR': 'Serum R · Piceatannol',
    'ronlan.ctaBtnA': 'Serum A · Retinoid',
    'ronlan.ctaBtnKit': 'Discovery Kit · alla fem',

    /* ── PDF download footer ── */
    'ronlan.dlNote': 'Föredrar du den ursprungliga handlingen?',
    'ronlan.dlLink': 'Ladda ner hela CV:t (PDF) →'

  });
})();
